export const MILLISECONDS_IN_1_MINUTE = 60000;

export const SECONDS_IN_1_MINUTE = 60;
export const SECONDS_IN_1_DAY = 86400;
export const SECONDS_IN_1_WEEK = 604800;
export const SECONDS_IN_1_MONTH = 2629743;
export const SECONDS_IN_1_YEAR = 31556926;
